export default {
  WIDGET: 'widget',
  FULL_SCREEN_MODALS: 'full-screen-modals',
  DASHBOARD: 'dashboard',
};



// WEBPACK FOOTER //
// ./src/shared/constants/application-names.js